import React from 'react';

import CommisionData from './CommisionData';
import styles from './commision.module.css';

const Commissions = () => {
  const { tableStyle } = styles;

  return (
    <div className="w-full px-4 py-6 my-3  bg-white shadow rounded-md border border-grey-1009">
      <div className="w-full relative m-auto lg:w-8/12">
        <table className={`table-fixed w-full ${tableStyle}`}>
          <thead>
            <tr className="text-base">
              <th className="w-1/10 py-2 text-left font-medium font-roboto">
                SL No
              </th>
              <th className="w-1/2 px-4  py-2 text-left font-medium font-roboto">
                Bank Name
              </th>
              <th className="w-1/5 px-4 py-2 text-left font-medium font-roboto">
                HL
              </th>
              <th className="w-1/5 px-4 py-2 text-left font-medium font-roboto">
                LAP
              </th>
            </tr>
          </thead>
          <tbody className="">
            {CommisionData.map(each => {
              const {
                SL_No,
                bankName,
                HLpercentage,
                LAPpercentage,
                imgUrl
              } = each;
              return (
                <tr key={SL_No} className="hover:bg-grey-1009">
                  <td className="px-4 py-2">{SL_No}</td>
                  <td className=" px-4 py-2 flex items-center">
                    {imgUrl ? <img src={imgUrl} className="w-12 h-12" /> : null}

                    <span className="pl-6">{bankName}</span>
                  </td>
                  <td className=" px-4 py-2">{HLpercentage}</td>
                  <td className=" px-4 py-2">{LAPpercentage}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="mt-4 font-roboto">
          <p className="font-medium">NOTES :</p>
          <ul className="list-decimal pl-4 text-black-500">
            <li>
              Minimum Home Loan (HL) and Loan Against Property (LAP) Lead value
              of Rs. 20 Lakhs.
            </li>
            <li>Payment Terms:</li>
            <ul>
              <li>
                (A) 10th of next month: For cases disbursed by 20th of prior
                month.
              </li>
              <li>
                (B) 25th of next month: For cases disbursed by 30th of prior
                month.
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Commissions;
